var _jsxFileName = "/codebuild/output/src449691236/src/bitbucket.org/newyuinc/adc-polaris-web/src/components/register/helpers/ContentContainer.tsx";
import React from 'react';
import { VStack } from '@adc/parallax-component-library';
function ContentContainer({
  children
}) {
  return /*#__PURE__*/React.createElement(VStack, {
    padding: "$4",
    paddingTop: "$2",
    gap: "$4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 7,
      columnNumber: 5
    }
  }, children);
}
export { ContentContainer };